import * as React from 'react'
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion'
import styled from '../../theme/styled'
import Tooltip, { Side } from './Tooltip'
const tooltips = require('./tooltips.json')

import 'react-accessible-accordion/dist/react-accessible-accordion.css'

const AccordionWrapper = styled(Accordion)`
  flex: 1;
`

const ItemWrapper = styled(AccordionItem)`
  margin: 0 0 8px 0;

  &:last-child {
    margin: 0;
  }

  padding: 2px 15px;
  background: ${({ theme }) => theme.projectTree.accordion.headerBackground};
  transition: background 1s;

  .accordion__body {
    margin: 15px 0;
    padding-bottom: 1px;
  }

  .item-title,
  .sub-item-title {
    display: flex;
    align-items: center;
    font-size: ${({ theme }) => theme.fonts.defaultSize};
    font-weight: 600;
    cursor: pointer;
    user-select: none;

    .num {
      text-transform: uppercase;
      margin-right: 15px;
      img {
        width: 22px;
        height: 22px;
      }

      .badge {
        background: ${({ theme }) => theme.colors.light};
        border-radius: 50%;
        height: 22px;
        width: 22px;
        display: inline-block;
        line-height: 22px;
        text-align: center;
        color: ${({ theme }) => theme.colors.invert};
      }
    }

    .title {
      text-transform: uppercase;
      flex: 1 0 auto;
    }

    .extra {
      text-transform: uppercase;
    }
  }

  .item-title {
    color: ${({ theme }) => theme.colors.default};
    padding: 5px;
  }

  .sub-item-title {
    position: relative;
    padding: 5px 15px;
    color: ${({ theme }) => theme.colors.invert};
    background: #8a999f;
  }

  &.item-expanded {
    background: ${({ theme }) => theme.projectTree.accordion.activeBackground};
    transition: background 1s;

    .toggle {
      transform: rotate(90deg);
    }
  }

  .sub-item-expanded .sub-toggle {
    transform: rotate(90deg);
  }
`

const OkImage = require('./check.svg')
const NokImage = require('./fail.svg')
const ArrowImage = require('./arrow_right.svg')

const checkmark = <img src={OkImage} alt="ok" />
const cross = <img src={NokImage} alt="invalid" />

type MarkProps = {
  touched: boolean
  valid: boolean
  num: number
}

function renderMark({ touched, valid, num }: MarkProps) {
  if (touched && valid) {
    return checkmark
  } else if (touched && !valid) {
    return cross
  } else {
    return <span className="badge">{num}</span>
  }
}

export const Item = props => (
  <ItemWrapper {...props} className={props.expanded ? 'item-expanded' : ''}>
    <AccordionItemTitle>
      <div
        className="item-title"
        onClick={() => props.onTitleClick && props.onTitleClick()}
      >
        <span className="num">{renderMark(props)}</span>
        <span className="title">{props.title}</span>
        {props.extra &&
          props.expanded && <span className="extra">{props.extra}</span>}
      </div>
    </AccordionItemTitle>
    <AccordionItemBody>{props.children}</AccordionItemBody>
  </ItemWrapper>
)

const Acc = props => (
  <AccordionWrapper {...props} accordion={true}>
    {props.children}
  </AccordionWrapper>
)

export { Accordion as SubAccordion }

export const SubItemWrapper = styled(AccordionItem)`
  .accordion__body {
    margin-left: 20px;
  }

  margin-bottom: 15px;
`

type SubAccordionProps = {
  title: string
  expanded?: boolean
  valid?: boolean
  extra?: string
}

type State = {
  tooltip: {
    id: string
    pos: { x: number; y: number }
  }
}

export class SubAccordionItem extends React.Component<
  SubAccordionProps,
  State
> {
  constructor(props: SubAccordionProps) {
    super(props)
    this.state = { tooltip: { id: '', pos: { x: 0, y: 0 } } }

    this.showTooltip = this.showTooltip.bind(this)
    this.hideTooltip = this.hideTooltip.bind(this)
  }

  showTooltip(event: React.MouseEvent<HTMLElement>) {
    const id = event.currentTarget.getAttribute('id')
    const rect = event.currentTarget.getBoundingClientRect()
    this.setState({
      tooltip: {
        ...this.state.tooltip,
        id: id ? id : '',
        pos: {
          x: rect.left + rect.width + 10,
          y: rect.top + rect.height / 2
        }
      }
    })
  }

  hideTooltip() {
    this.setState({ tooltip: { ...this.state.tooltip, id: '' } })
  }

  render() {
    const tooltipText =
      this.props.title === 'Final composite'
        ? tooltips.finalComposite
        : tooltips.installation
    return (
      <SubItemWrapper
        {...this.props}
        className={this.props.expanded ? 'sub-item-expanded' : ''}
      >
        <AccordionItemTitle>
          <div
            id={this.props.title}
            className="sub-item-title"
            onMouseEnter={this.showTooltip}
            onMouseLeave={this.hideTooltip}
          >
            <span className="num">
              <img className="sub-toggle" src={ArrowImage} />
            </span>
            <span className="title">{this.props.title}</span>
            {this.props.valid && <span className="extra">{checkmark}</span>}
            {this.props.extra && (
              <span className="extra">{this.props.extra}</span>
            )}
            <Tooltip
              tooltip={{
                text: tooltipText,
                pos: this.state.tooltip.pos,
                show: this.state.tooltip.id === this.props.title,
                side: Side.Right
              }}
            />
          </div>
        </AccordionItemTitle>
        <AccordionItemBody>{this.props.children}</AccordionItemBody>
      </SubItemWrapper>
    )
  }
}

export default Acc



// WEBPACK FOOTER //
// ./src/Components/Shared/Accordion.tsx